import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { LegalAgreements } from 'components';
import { locations } from 'services/routes/locations';

type FormFooterType = {
  text?: string;
  link?: string;
};

const FormFooter = ({ text, link }: FormFooterType) => {
  const theme = useTheme();

  return (
    <Box sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(4) }}>
      {text && (
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.grey[400],
          }}
          align="left"
          color="inherit"
        >
          {text}
        </Typography>
      )}
      {link && (
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.grey[400],
          }}
          component={Link}
          to={locations.general.passwordReset.pathname}
          align="left"
          color="inherit"
        >
          {link}
        </Typography>
      )}

      <LegalAgreements />
    </Box>
  );
};

export default FormFooter;
